import { Worker } from "../util";
export default class SamoodecetBatchCtrl {


  constructor(SamoodpocetService, OdberneMiestoService, typOM){
    this.SamoodpocetService = SamoodpocetService;
    this.OdberneMiestoService = OdberneMiestoService;
    this.importXls = Worker(this._importXls);
    this.typOM = typOM;
    this.save = Worker(this._save);
    this.file = null;
    this.orders = [];
  }

  onFile($file){
    this.file = $file;
  }

  _importXls(){
    return this.SamoodpocetService.readXls(this.typOM, this.file).then(orders => this.orders = orders);
  }

  _save(){
    return this.SamoodpocetService.submit(this.orders).then(orders => {
      this.orders = orders;
      this.orders.forEach(order => {
        if(order.status == 0) order.status = 2;
      })
    });
  }

  cancel(){
    this.orders = [];
    this.save = Worker(this._save);
  }

  exportXls(){
    this.OdberneMiestoService.exportSamoodpocet(this.typOM);
  }

  formatNumber(n){
    if(n === undefined){
      return undefined;
    }
    return (""+(+n).toFixed(3)).replace(".", ",");
  }

  getTypOdpoctu(typ){
    var options = {
      "K":"K (Kontrolní odečet)",
      "F":"F (Fakturační odečet)",
      "Z":"Z (odečet ke Změně dodavatele)",
      "P":"P (odečet při Přepisu)",
      "N":"N (kontrolní odečet Novým dodavatelem)",
      "U":"U (odečet k Ukončení dodávky z OTE)",
      "C":"Ke změně ceny k 31. 12.",
      "M":"Pro vystavení mimořádné faktury ke změně ceny",
      "X":"Nespecifikovaný důvod",
    };
    return options[typ] || typ;
  }




}


// WEBPACK FOOTER //
// ./src/Samoodpocet/SamoodpocetBatchCtrl.js